import Sidebar, { SidebarItemProps } from '@repo/ui/components/Sidebar';
import { useNavigate } from '@tanstack/react-router';
import { useLogout, useSession } from '../hooks/auth';
import { Users, ShieldCheck, LayoutDashboard, UserCircle, LogOut, Activity } from 'lucide-react';

export default function MainSidebar() {
  const navigate = useNavigate();
  const { mutateAsync: logout } = useLogout({
    onSuccess: () => {
      navigate({ to: '/login', replace: true });
    },
  });

  const { session, loading } = useSession();

  if (!session && !loading) return null;

  const items = (
    [
      session?.iselevated && {
        label: 'Team Insights',
        icon: <Activity size={20} />,
        to: '/team-insights',
      },
      session?.iselevated &&
        session?.isglobal && {
          label: 'CRM',
          icon: <Users size={20} />,
          to: '/crm',
        },
      session?.iselevated &&
        session?.isglobal && {
          label: 'Admin',
          icon: <ShieldCheck size={20} />,
          to: '/admin',
        },
      {
        label: 'My Insights',
        icon: <LayoutDashboard size={20} />,
        to: '/my-insights',
      },
      {
        label: 'Profile',
        icon: <UserCircle size={20} />,
        to: '/profile',
        isBottomItem: true,
      },
      {
        label: 'Logout',
        icon: <LogOut size={20} />,
        onClick: async () => await logout(),
        isBottomItem: true,
      },
    ] satisfies (SidebarItemProps | false | undefined)[]
  ).filter(item => !!item) as SidebarItemProps[];

  return <Sidebar items={items} />;
}
